/**

事件：

    connected
    closed
    error
    recv

 */

    import ZJNotify from '../../notify';
    import utils from '../../utils';
    import MediaCenterMsg from './MediaCenterMsg';
    
    const MediaCenter = function(opts) {
        opts = opts || {};
        
        let appConfig = {
            address : this.$appConfig ?this.$appConfig.getValue('mediaCenter.address', this.config.address): this.config.address,
            mode : (this.$appConfig ? this.$appConfig.getValue('mediaCenter.mode', this.config.mode): this.config.mode) || 'tcp'
        };
    
        // 优先级  实例化传参 > 配置文件 > 变量
        this.config = utils.extend({}, this.config, appConfig, opts);
        this.$sock = null;
        this.$events = {};
        this.$buf = new utils.Buffer(8 * 1024); // 接收缓存
    
        this.$connectResolve = [];
        this.$connectReject = [];
    };
    
    const pt = MediaCenter.prototype;
    
    pt.config = {
        address: '192.168.58.213:8282',
        mode: 'tcp' // tcp|upd - 连接媒体中心的方式
    };
    
    utils.EventExtend.install(pt);
    
    pt._resolveConnect = function (succ, data) {
        let arr = succ ? this.$connectResolve : this.$connectReject;
        this.$connectResolve = [];
        this.$connectReject = [];
        for(let i = 0;i < arr.length; i++) {
            arr[i](data);
        }
    };
    
    pt.connect = function() {
        const that = this;
        if (this.$connected) {
            return Promise.resolve({
                ip: that.$ip,
                port: that.$port,
                mode: that.$mode
            });
        }
        else if (this.$connecting) {
            return new Promise(function(resolve, reject) {
                that.$connectResolve.push(resolve);
                that.$connectReject.push(reject);
            });
        }
        else {
            return new Promise(function(resolve, reject) {
                that._connect(resolve, reject);
            });
        }
    };
    
    pt._connect = function(resolve, reject) {
        const address = this.config.address;
        const mode = (this.config.mode) || 'tcp';
        let index = address.lastIndexOf(':');
        const ip = address.substr(0, index);
        const port = parseInt(address.substr(index + 1));
        
        this.$ip = ip;
        this.$port = port;
        this.$mode = mode;
        this.$connecting = true;
        this.$connected = false;
        this.$connectResolve.push(resolve);
        this.$connectReject.push(reject);
    
        let sock = this.$sock = new ZJNotify.Socket(ip, port, mode);
    
        this.$buf.count = 0;
    
        const that = this;
    
        sock.on('open', function () {
            that.$connecting = false;
            that.$connected = true;
            let d = {
                ip: ip,
                port: port,
                mode: mode
            };
            that.$emit('connected', {
                name: 'connected',
                data: d
            });
            that._resolveConnect(true, d);
        });
    
        sock.on('close', function (e) {
            if (that.$sock === this) {
                that.$connecting = false;
                that.$connected = false;
                that.$sock = null;
            }
            that.$emit('closed', {
                name: 'closed',
                data: e.data
            });
        });
    
        sock.on('error', function (e) {
            console.error('error', e);
            that.$emit('error', {
                name: 'error',
                error: e.error
            });
            if (that.$connecting) {
                that.$connecting = false;
                that.$sock = null;
                that._resolveConnect(false, e);
            }
            this.close();
        });
    
        sock.on('recv', function (e) {
            try {
                if (that.$sock !== this) return;
                const msgs = [];
                const data = new Uint8Array(e.data);
                MediaCenterMsg.writeBuffer(that.$buf, {
                    buffer: data,
                    offset: 0,
                    count: data.length
                }, function(msg) {
                    msgs.push(msg);
                });
                if (msgs.length > 0) {
                    for (let i = 0;i < msgs.length; i++) {
                        that.onRecv(msgs[i]);
                    }
                }
            }
            catch(ex) {
                console.error('error', ex, e);
                that.$emit('error', {
                    name: 'error',
                    error: ex
                });
                this.close();
            }
        });
    
        sock.open();
    };
    
    pt.close = function() {
        if (this.$sock) {
            this.$sock.close();
            this.$connecting = false;
            this.$connected = false;
            this.$sock = null;
        }
    };
    
    pt.sendPing = function() {
        this.sendCmd(MediaCenterMsg.PING);
    };
    
    pt.sendPong = function() {
        this.send(MediaCenterMsg.RESPONSE, MediaCenterMsg.PONG);
    };
    
    // 发送停止指令
    pt.sendStop = function () {
        this.sendCmd(MediaCenterMsg.STOP);
    };
    
    // 发送预览指令
    pt.sendPreview = function(data) {
        this.sendCmd(MediaCenterMsg.PREVIEW, data || {});
    };
    
    // 发送回放指令
    pt.sendPlayback = function(data) {
        this.sendCmd(MediaCenterMsg.PLAYBACK, data || {});
    };
    
    // 发送改变大小指令
    pt.sendResize = function(data) {
        this.sendCmd(MediaCenterMsg.RESIZE, data || {});
    };
    
    pt.sendCmd = function(cmd, data) {
        this.send(MediaCenterMsg.REQUEST, cmd, data);
    };
    
    pt.send = function(msgType, msgCode, msgData) {
        const buf = MediaCenterMsg.build(msgType, msgCode, msgData);
        this.$sock.send(buf, 0, buf.length);
    };
    
    pt.onRecv = function (msg) {
        if (msg.isPong()) {
            // do nothing
            console.debug('recv pong');
        }
        else if (msg.isPing()) {
            console.debug('recv ping');
            this.sendPong();
        }
        else {
            this.$emit('msg', {
                name: 'msg',
                data: msg
            });
        }
    };
    
    MediaCenter.install = function(Vue, opts) {
        opts = opts || {};
        const cnf = opts.config;
        if (cnf) {
            pt.$appConfig = cnf;
        }
    };
    
    export default MediaCenter;
    